import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';
import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';
import {ApplicationConfig} from '#core/config/application-config.js';

class AzOverviewFeature extends AbstractFeature {
    afterMojitoConfigBuild(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');
        const mobileInfoSectionItems = ApplicationConfig.config.mobileInfoSectionItems;

        mergeTo(configurations, {
            AzOverview: {
                informationSectionItems: [
                    ...buildIntentsFromConfig(mobileInfoSectionItems),
                    {
                        label: '$AZ_MENU.SETTINGS_LABEL',
                        step: 'settings',
                        className: 'ta-settingsButton',
                    },
                ],
            },
        });
        super.afterMojitoConfigBuild(mojitoConfig);
    }
}

new AzOverviewFeature(allFeatures);
